<template>
  <KmTooltip bottom>
    <KmIcon
      slot="activator"
      class="status-icon-component"
      :name="icon"
      :color="color"
      :title="title"
    />
    {{ title }}
  </KmTooltip>
</template>

<script>
import getAppInfos from '@/utils/getAppInfos'
import isServerOffline from '@/utils/isServerOffline'
import KmIcon from '@/components/KmIcon'
import KmTooltip from '@/components/KmTooltip'

export default {
  name: 'StatusIcon',

  components: {
    KmIcon,
    KmTooltip,
  },

  props: {
    mode: {
      type: String,
      required: true,
      validator(value) {
        return value === 'app' || value === 'server'
      },
    },

    name: {
      type: String,
      required: true,
    },

    query: {
      type: Object,
      required: true,
    },
  },

  computed: {
    icon() {
      if (this.mode === 'server') return 'km-icon-servers'
      return getAppInfos(this.name).icon
    },

    _state() {
      if (this.mode === 'app') {
        const processes = this.$store.getters.select(this.query).processes
        if (processes.every(process => process.status === 'online')) return 'online'
        if (processes.some(process => process.status === 'online')) return 'partial'
        return 'offline'
      }
      return isServerOffline(this.name) ? 'offline' : 'online'
    },

    color() {
      return this._state === 'online' ? 'primary' : this._state === 'partial' ? 'warning' : 'error'
    },

    title() {
      const subject = this.mode === 'app' ? 'App' : 'Server'
      return this._state === 'online'
        ? `${subject} is online: displayed data is in real time`
        : this._state === 'partial'
        ? `${subject} is partially offline: displayed data may not be accurate`
        : `${subject} is offline: displayed data is not in real time`
    },
  },
}
</script>

<style lang="postcss" scoped></style>
